module.exports = __webpack_public_path__ + "img/card-bg-02.47a63641.png";